import React from 'react';
import { termsDataMonths } from '../../enums/termsData'

export default function template(context) {
  const calc = context.calc,
    model = calc.state.model,
    isMobile = calc.isViewportMobile(),
    termBtns = (
      <div className="calculator-terms-wrapper">
        {model.getTerms().map((item, index) => {
          return (
            <button className={`term-btn ${item === Number(model.getCreditTerm()) ? 'active' : ''}`} name="loanTerm" key={item} onClick={calc.handleChange} value={index}>
              {termsDataMonths[item].value} {calc.l10n(termsDataMonths[item].text)}
            </button>
          )
        })}
      </div>
    ),
    amountBtns = (
      <div className="calculator-amount-wrapper">
        {model.getFixAmounts().map((item, index) => {
          return (
            <button className={`amount-btn ${+item === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum" key={index} onClick={calc.handleChange} value={item}>
              {(+item).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
          )
        })}
      </div>
    ),
    error = calc.state.error
      ? (<div className="error-text">{`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}</div>)
      : '';
  return (
    <React.Fragment>
      <div className="calculator-controllers">
        <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
        <div className="calc-mode-description">
          {calc.l10n("PROFIT_CARD_CALC_SUBTITLE")}
          <div className="green">{model.getRealRate() + calc.l10n("PERCENT")}</div>
        </div>
        <div className={`controller-block ${calc.state.error ? 'error' : ''}`}>
          <div className="calc-block-title">
            {calc.l10n('CREDIT_PBP_SUM')}
            {isMobile ? <br/> : ''}
            <span className="calc-block-title-sum">
            {` (${calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} ${model.getMinSumEdge()} ${calc.l10n('CALCULATOR_CREDIT_SUM_TO')} ${model.getMaxSumEdge()} ${calc.l10n('UAH_ICON')})`}
          </span>
          </div>
          <div className="calculator-slider-wrapper">
            <div className="calculator-input-wrapper">
              <input name="creditSum" type="text"
                     className="calculator-slider-value"
                     value={model.getCreditSum().toLocaleString('uk-UA')}
                     onChange={calc.handleChangeInput}
                     onBlur={calc.blurChangeInput}
                     max={model.getMaxSumEdge()}
                     min={model.getMinSumEdge()}>
              </input>
              <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
              <span style={model.getCreditSum() === 500 ? {left: "44px"} : {left: `${calc.state.valueWith}px`}}>{calc.l10n('UAH_ICON')}</span>
            </div>
          </div>
          <input type="range"
                 name="creditSum"
                 className="calculator-sum-slide"
                 onChange={calc.handleChange1}
                 value={model.getCreditSum()}
                 min={model.getMinSumEdge()}
                 max={model.getMaxSumEdge()}
                 step={model.getSumStep()}
                 style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent}%, transparent ${calc.state.rangePercent}%)`}}
          />
        </div>
        {error}
        {amountBtns}
        <div className="controller-block terms">
          <div className="calc-block-title">
            {calc.l10n('CALCULATOR_CREDIT_FORM_TITLE')}
            <span className="calc-block-title-sum">
            {` (${calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} ${model.getMinTermEdge()} ${calc.l10n('CALCULATOR_CREDIT_SUM_TO')} ${model.getMaxTermEdge()} ${calc.l10n('CALCULATOR_FULL_MONTHS')})`}
          </span>
          </div>
          {termBtns}
        </div>
      </div>
    </React.Fragment>
  );
}
